import * as yup from 'yup'
import { linkValidation } from 'components/Project/IsaacTable'
import { IProductsByCampaign } from '../types'
import { AnyObject } from 'yup/es/types'

const rules = {
  projectName: { required: 'Project name is required.' },
  projectOwner: { required: 'Project owner is required.' },
  unit: { required: 'Unit is required.' },
  opusId: { required: 'Opus ID is required.' },
  gpsStatus: { required: 'GPS Artist Status ID is required.' },
  configuration: { required: 'Type is required.' },
  publish_date: { required: 'Release Date is required.' },
  searchedName: { required: 'Artist is required.' }
}

export default rules

export const projectSchema = yup.object().shape({
  isaacUrl: linkValidation
})

interface IAsyncProductSchema {
  checkUserEmail: (email: string) => Promise<{ id: number; email: string }>
}

export const asyncProjectSchema = ({ checkUserEmail }: IAsyncProductSchema) =>
  yup.object().shape({
    isaacUrl: linkValidation,
    ownerEmail: yup
      .string()
      .required('Project owner is required')
      .email('Invalid email address')
      .test('ownerEmail', 'User is not exist', async (email) => {
        if (typeof email === 'string') {
          try {
            await checkUserEmail(email)
            return true
          } catch {
            return false
          }
        }
        return false
      })
  })

type TProductValidate = (item: IProductsByCampaign) => undefined | string

function productUniqueName(list: ReadonlyArray<IProductsByCampaign> = [], { createError, path, parent }: AnyObject) {
  const { name, configuration } = list[parent.editRow]
  for (let i = 0;i < list.length;i++) {
    if (i !== parent.editRow && name === list[i].name && configuration === list[i].configuration) {
      return createError({ path: `${path}[${parent.editRow}].name` })
    }
  }
  return true
}

function checkUniqueNameInProject(check: TProductValidate) {
  return (list: ReadonlyArray<IProductsByCampaign> = [], { createError, path, parent }: AnyObject) => {
    const result = check(list[parent.editRow])
    if (typeof result !== 'undefined') {
      return createError({ path: `${path}[${parent.editRow}].name`, message: result })
    }
    return true
  }
}

declare module 'yup' {
  interface ArraySchema<T> {
    uniqueNameInProject(): ArraySchema<T>
  }
}

export const productSchema = (check: TProductValidate) => {

  yup.addMethod(yup.array, 'uniqueName', function (message) {
    return this.test('uniqueName', message, productUniqueName)
  })

  yup.addMethod(yup.array, 'uniqueNameInProject', function (createMessage) {
    return this.test('uniqueNameInProject', createMessage, checkUniqueNameInProject(check))
  })

  return yup.object().shape({
    products: yup
      .array(
        yup.object()
          .shape({
            name: yup.string().required('Product Name is required.'),
            configuration: yup.string().required('Type is required.'),
            publish_date: yup.string().required('Release Date is required.')
          })
      )
      .when('editRow', {
        is: (value?: number) =>typeof value !== 'undefined',
        then: schema => schema
          .uniqueName('Product has already been taken.')
          .uniqueNameInProject(),
      })
  })
}
